import { ServiceBase } from '../../../../core/services/ServiceBase'
import DynamicReportProxy from './proxy'

class DynamicReportService extends ServiceBase {
  getTemplates(params) {
    return this.getData(() => DynamicReportProxy.getTemplates(params))
  }
  deleteTemplates(params) {
    return this.getData(() => DynamicReportProxy.deleteTemplates(params), true)
  }
  updateTemplate(params) {
    return this.getData(() => DynamicReportProxy.updateTemplate(params), true)
  }
  saveTemplate(params) {
    return this.getData(() => DynamicReportProxy.saveTemplate(params), true)
  }
  uploadFileDynamic(params) {
    return this.getData(() => DynamicReportProxy.uploadFileDynamic(params))
  }
}

export default new DynamicReportService()
